import React, { useMemo } from 'react';
import moment from 'moment';

const CalculateTotalWorkingHours = ({ punchList }) => {
  const { hours, minutes } = useMemo(() => {
    // 1. Initialize a duration of 0
    let totalDuration = moment.duration(0);

    // 2. Loop through the list
    punchList.forEach((punch) => {
      // GUARD: Skip if outTime is null, undefined, or an empty string
      if (!punch.inTime || !punch.outTime) {
        return; 
      }

      const start = moment(punch.inTime);
      const end = moment(punch.outTime);

      // Ensure the end time is actually after the start time
      if (end.isAfter(start)) {
        const diff = moment.duration(end.diff(start));
        totalDuration.add(diff);
      }
    });

    // 3. Extract formatted totals
    return {
      hours: Math.floor(totalDuration.asHours()),
      minutes: totalDuration.minutes(),
    };
  }, [punchList]);

  return (
    <div style={{ padding: '15px', border: '1px solid #eaeaea', borderRadius: '10px' }}>
      <h3 style={{ margin: '0 0 10px 0' }}>Work Summary</h3>
      <p style={{ fontSize: '1.2rem' }}>
        Total: <strong>{hours}</strong> hrs <strong>{minutes}</strong> mins
      </p>
      {/* Optional: Add a small note if some records were skipped */}
      <small style={{ color: '#888' }}>
        (Calculated based on completed punch cycles)
      </small>
    </div>
  );
};

export default CalculateTotalWorkingHours;